export default {
  state: {
    pn: null, // 数采器编号
    sn: null,  // 设备序列号(用于接口调用)
    deviceSn: null, // 设备SN(用于展示)
    devaddr: null, // 设备地址
    devcode: null, // 设备协议编码
    status: null, // 设备状态码
    devalias: null, // 设备别名
    pid: null, // 电站id
    descx: null, // 数采器类型
    load: null, // 带载数
    edate: null, // 流量到期时间

    // 增
    brand: null,//
    devtype: null,//
    device_Firmware_Version: null,//
    Firmware_Version: null,//
    // 当前时间戳 解决generalNew\device\index下监听deviceInfo未改变this.$router.push('/home')返回后空白页
    currentDate: null,
    collalias: null,//
    mqttStatus: false, // MQTT连接状态
    profitToday: "",//当日收益
    profitTotal: "",//累计收益
    sellProfitToday: "",//日卖电收益
    sellProfitTotal: "",//总卖电收益
    buyProfitToday: "",//日买电收益
    buyProfitTotal: "",//总买电收益
    otaLabel: "",//OTA升级标识

    // focus: "",
    usr: "", // 辅助切换设备查看信息
    uid: "", // 辅助切换设备查看信息
    plantidCur: "", // 辅助经销商设备管理切换项目获取设备列表
    curIsFollow: false, // 辅助经销商当前选中我的关注
    // plantidCurTo: "", // 辅助管理员跳转普通用户查看项目
    isShow:1,
    UsrPermission:1,//厂家分配用户权限
    signal:"",//信号值
    dataloggerDetail:1,//数采器详情调试标识
    upgradeUPG:false,//是否启用透传升级
    upgradeUPGList:[],//
    UpgradeTypeUPG:false,//升级方式判断标识（通过设备四要素查询设备的升级方式，与上方的upgradeUPG通过协议判断升级方式是不一样的）
  },
  getters: {
    // 获取设备信息
    getDeviceInfo: state => {
      return {
        pn: state.pn,
        sn: state.sn,
        deviceSn: state.deviceSn,
        devaddr: state.devaddr,
        devcode: state.devcode,
        status: state.status,
        devalias: state.devalias,
        pid: state.pid,
        descx: state.descx,
        load: state.load,
        edate: state.edate,
        // 增
        focus: state.focus,
        // 增
        usr: state.usr,
        // 增
        uid: state.uid,
        // 增
        brand: state.brand,
        // 增
        devtype: state.devtype,
        // 增
        device_Firmware_Version: state.device_Firmware_Version,
        // 增
        Firmware_Version: state.Firmware_Version,
        // 增
        currentDate: state.currentDate,
        // 增
        collalias: state.collalias,
        signal: state.signal,
        profitToday: state.profitToday,
        profitTotal: state.profitTotal,
        sellProfitToday: state.sellProfitToday,
        sellProfitTotal: state.sellProfitTotal,
        buyProfitToday: state.buyProfitToday,
        buyProfitTotal: state.buyProfitTotal,
        otaLabel: state.otaLabel,
      }
    },
    // [获取经销商当前选中项目ID]
    getPlantidCur: state => {
      return {
        plantidCur: state.plantidCur,
      }
    },
    // [获取管理员要跳转普通用户查看项目ID]
    // getPlantidCurTo: state => {
    //   return {
    //     plantidCurTo: state.plantidCurTo,
    //   }
    // },
    // [获取经销商当前选中我的关注]
    getCurIsFollow: state => {
      return {
        curIsFollow: state.curIsFollow,
      }
    },
    getIsShow: state => {
      return {
        isShow: state.isShow,
      }
    },
    getDataloggerDetail: state => {
      return {
        dataloggerDetail: state.dataloggerDetail,
      }
    },
    getUpgradeUPG: state => {
      return {
        upgradeUPG: state.upgradeUPG,
      }
    },
    getUpgradeTypeUPG: state => {
      return {
        UpgradeTypeUPG: state.UpgradeTypeUPG,
      }
    },
  },
  mutations: {
    // 保存设备信息
    saveDeviceInfo(state, { pn, sn, devaddr, devcode, status, devalias, pid,descx,load,edate, focus, usr, uid, brand, devtype, device_Firmware_Version,Firmware_Version, collalias,signal,profitToday,profitTotal,sellProfitToday,sellProfitTotal,buyProfitToday,buyProfitTotal,otaLabel, deviceSn}) {
      if (pn !== undefined) state.pn = pn
      if (sn !== undefined) state.sn = sn
      if (deviceSn !== undefined) state.deviceSn = deviceSn
      if (devaddr !== undefined) state.devaddr = devaddr
      if (devcode !== undefined) state.devcode = devcode
      if (status !== undefined) state.status = status
      if (devalias !== undefined) state.devalias = devalias
      if (pid !== undefined) state.pid = pid
      if (descx !== undefined) state.descx = descx
      if (load !== undefined) state.load = load
      if (edate !== undefined) state.edate = edate
      // 增
      if (focus !== undefined) state.focus = focus
      // 增
      if (usr !== undefined) state.usr = usr
      // 增
      if (uid !== undefined) state.uid = uid
      // 增
      if (brand !== undefined) state.brand = brand
      // 增
      if (devtype !== undefined) state.devtype = devtype
      // 增
      if (device_Firmware_Version !== undefined) state.device_Firmware_Version = device_Firmware_Version
      // 增
      if (Firmware_Version !== undefined) state.Firmware_Version = Firmware_Version
      // 增
      state.currentDate = Date.now()
      // 增
      if (collalias !== undefined) state.collalias = collalias
      if (signal !== undefined) state.signal = signal
      if (profitToday !== undefined) state.profitToday = profitToday
      if (profitTotal !== undefined) state.profitTotal = profitTotal
      if (sellProfitToday !== undefined) state.sellProfitToday = sellProfitToday
      if (sellProfitTotal !== undefined) state.sellProfitTotal = sellProfitTotal
      if (buyProfitToday !== undefined) state.buyProfitToday = buyProfitToday
      if (buyProfitTotal !== undefined) state.buyProfitTotal = buyProfitTotal
      if (otaLabel !== undefined) state.otaLabel = otaLabel
    },
    // [保存经销商当前选中项目ID]
    savePlantidCur(state, { plantidCur}) {
      if (plantidCur !== undefined) state.plantidCur = plantidCur
    },
    // [保存管理员要跳转普通用户查看项目ID]
    // savePlantidCurTo(state, { plantidCurTo}) {
    //   if (plantidCurTo !== undefined) state.plantidCurTo = plantidCurTo
    // },
    // [保存经销商当前选中我的关注]
    saveCurIsFollow(state, { curIsFollow}) {
      if (curIsFollow !== undefined) state.curIsFollow = curIsFollow
    },
    saveIsShow(state, isShow) {
      if (isShow !== undefined) state.isShow = isShow
    },
    // 厂家分配用户权限
    saveUsrPermission(state, UsrPermission) {
      if (UsrPermission !== undefined) state.UsrPermission = UsrPermission
    },
    saveUpgradeUPG(state, upgradeUPG) {
      if (upgradeUPG !== undefined) state.upgradeUPG = upgradeUPG
    },
    saveUpgradeTypeUPG(state, UpgradeTypeUPG) {
      if (UpgradeTypeUPG !== undefined) state.UpgradeTypeUPG = UpgradeTypeUPG
    },
    saveUpgradeUPGItems(state, upgradeUPGList) {
      if (upgradeUPGList !== undefined) state.upgradeUPGList = upgradeUPGList
    },
    saveDataloggerDetail(state, dataloggerDetail) {
      if (dataloggerDetail !== undefined) state.dataloggerDetail = dataloggerDetail
    },
    changeMqttStatus(state, status) {
      state.mqttStatus = status
    },
  },
  actions: {
  }
}